<template>
	<div class="main-varieties-rise-and-fall-wrapper">
		<transition name='mv'>
			<ul v-if="list.length > 0">
				<li v-for="li in list">
					<div class="left">{{li.name}}</div>
					<div class="right" :class="li.icon">
						<span v-if="li.icon">
							<font-awesome-icon :icon="'arrow-'+li.icon" class="price_icon"/>¥{{li.price}}
						</span>
						<span v-else>
							—
						</span>
					</div>
				</li>
			</ul>
		</transition>
	</div>
</template>
<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import '@fortawesome/fontawesome-free-solid'

export default {
	components: { FontAwesomeIcon },
	props: {
		db: {
			type: Array,
			default () {
				return [];
			}
		}
	},
	data() {
		return {
			list: [{
				name: '加载中...',
				icon: '',
				price: '0000.00',
			}]
		}
	},
	mounted() {
		this.list = JSON.parse(JSON.stringify(this.$props.db));
	},
	watch: {
		db(val,oldVal) {
			if(JSON.stringify(val) != JSON.stringify(oldVal)) {
				this.list = []
				this.reloadData();
			}
		}
	},
	methods: {
		reloadData() {
			clearTimeout(this.popTimeout);
			this.popTimeout = setTimeout(() => {
				this.list = JSON.parse(JSON.stringify(this.$props.db));
				clearTimeout(this.popTimeout);
			}, 500);
		}
	}
}

</script>
<style scoped>
	.left {
		float: left;
		width: 65%;
		font-weight: bold;
		padding-left: 25px;
		box-sizing: border-box;
	}
	.right {
		float: right;
		width: 32%;
		box-sizing: border-box;
		color: rgba(255,255,255,.5);
		padding-right: 25px;
		text-align: right;
	}
	ul,li {
		list-style: none;
		padding: 0;
		margin: 0;
		line-height: 43px;
	}
	.price_icon {
		margin-right: 8px;
	}
	.right.up {
		color: #20a0ff;
	}
	.mv-enter,.mv-leave-to {
		transform: scaleX(0);
		opacity: 0;
		transition: .5s
	}
	.mv-enter-active,.mv-leave-active {
		transition: .5s
	}
	/*ul li {
		display: block;
	}
	ul li:nth-child(1) {
		transform-origin: center 21px;
		animation: swipe 10s infinite;
	}
	ul li:nth-child(2) {
		transform-origin: center 64px;
		animation: swipe 10s infinite ease .3s;
	}
	ul li:nth-child(3) {
		transform-origin: center 107px;
		animation: swipe 10s infinite ease .6s;
	}
	ul li:nth-child(4) {
		transform-origin: center 150px;
		animation: swipe 10s infinite ease .9s;
	}
	ul li:nth-child(5) {
		transform-origin: center 193px;
		animation: swipe 10s infinite ease 1.2s;
	}
	ul li:nth-child(6) {
		transform-origin: center 236px;
		animation: swipe 10s infinite ease 1.5s;
	}
	@keyframes swipe {
		0% {transform: scaleY(1);opacity: 1}
		3% {transform: scaleY(0);opacity: .5}
		6% {transform: scaleY(1);opacity: 1}
		100% {transform: scaleY(1);opacity: 1}
	}*/
</style>



// WEBPACK FOOTER //
// src/components/charts/MainVarietiesRiseAndFall.vue